import { ApolloLink } from "@apollo/client";

let authToken = null;

export function setAuthToken(value) {
  authToken = value;
  return authToken;
}

export function getAuth() {
  if (authToken) {
    return `Bearer ${authToken}`;
  }
}

const authLink = new ApolloLink((operation, forward) => {
  const auth = getAuth();
  const { headers = {} } = operation.getContext();

  operation.setContext({
    headers: {
      ...headers,
      authorization: auth || "",
    },
  });

  return forward(operation);
})

export default authLink;